import { useQuery } from '@tanstack/react-query'
import type { Permission } from '@mira/shared/permissions'
import { authApi } from './api'

export const meQueryKey = ['me'] as const

export function useMe() {
  return useQuery({ queryKey: meQueryKey, queryFn: authApi.me, staleTime: 60_000 })
}

/** Permission check for UI decisions (hiding/disabling). The API is the real boundary. */
export function useCan() {
  const { data } = useMe()
  const set = new Set<string>(data?.permissions ?? [])
  return (perm: Permission) => set.has(perm)
}
